import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="quote-items"
export default class extends Controller {
  connect() {
    console.log("quoteItemsController connected");
  }

  async autoCalculateAll() {
    const branchId = document.querySelector("[id$=_branch_id]").value;
    document
      .querySelectorAll("[data-controller='quote-item']")
      .forEach((rowControllerElement) => {
        const controller =
          this.application.getControllerForElementAndIdentifier(
            rowControllerElement,
            "quote-item"
          );

        controller.autoCalculate(branchId);
      });
  }

  calculateQuoteEstimatedPrice() {
    const estimated_price = document.querySelectorAll(
      "[name=quote-items] [id$=_price]"
    );
    const priceElementsArray = Array.from(estimated_price);
    const total_estimated_price = priceElementsArray.reduce(
      (prev, current) => prev + (parseFloat(current.value) || 0),
      0
    );

    document.querySelectorAll("[id$=_estimated_price]").forEach((el) => {
      el.value = total_estimated_price;
    });
  }

  async createOrderFromQuoteItems() {
    // No jQuery and ajax use Stimulus, vanilla JS and fetch instead
    if (!confirm("本当に受付を作成しますか？")) return;

    const quote_item_ids = Array.from(
      document.querySelectorAll("[name*=quote_item_ids]:checked")
    ).map((el) => el.value);

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/quote_items/create_orders`, {
      method: "POST",
      headers: {
        Accepted: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ quote_item_ids })
    });

    if (response.ok) {
      const data = await response.json();
      window.location.href = `/orders/${data.order_id}/edit`;
    } else {
      console.error("Failed to create order from quote items");
    }
  }
}
